import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';


const BaseFormContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: `
      radial-gradient(ellipse at 20% 10%, rgba(89, 18, 51, 0.22) 0%, transparent 52%),
      radial-gradient(ellipse at 80% 90%, rgba(64, 13, 41, 0.18) 0%, transparent 48%),
      rgba(26, 8, 20, 0.88)
    `,
    padding: '40px 30px',
    borderRadius: '20px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
    width: '90%',
    maxWidth: '420px',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(89, 18, 51, 0.2)',
  }));

  export default BaseFormContainer